// data taken from https://www.citypopulation.de/Peru.html
export const addressData = {
    "PE": {
        "Tumbes": {
            number: "01",
            districts: [
                "Canoas de Punta Sal",
                "Casitas",
                "Zorritos",
                "Corrales",
                "La Cruz",
                "Pampas de Hospital",
                "San Jacinto",
                "San Juan de la Virgen",
                "Tumbes",
                "Aguas Verdes",
                "Matapalo",
                "Papayal",
                "Zarumilla"
            ]
        },
        "Piura": {
            number: "02",
            districts: [
                "Ayabaca",
                "Frías",
                "Jililí",
                "Lagunas",
                "Montero",
                "Pacaipampa",
                "Paimas",
                "Sapillica",
                "Sícchez",
                "Suyo",
                "Canchaque",
                "El Carmen de la Frontera",
                "Huancabamba",
                "Huarmaca",
                "Lalaquiz",
                "San Miguel de El Faique",
                "Sóndor",
                "Sondorillo",
                "Buenos Aires",
                "Chalaco",
                "Chulucanas",
                "La Matanza",
                "Morropón",
                "Salitral",
                "San Juan de Bigote",
                "Santa Catalina de Mossa",
                "Santo Domingo",
                "Yamango",
                "Amotape",
                "Arenal",
                "Colán",
                "La Huaca",
                "Paita",
                "Tamarindo",
                "Vichayal",
                "Castilla",
                "Catacaos",
                "Cura Mori",
                "El Tallán",
                "La Arena",
                "Las Lomas",
                "La Unión",
                "Piura",
                "Tambo Grande",
                "Veintiséis de Octubre",
                "Bellavista de la Unión",
                "Bernal",
                "Cristo nos Valga",
                "Rinconada-Llicuar",
                "Sechura",
                "Vice",
                "Bellavista",
                "Ignacio Escudero",
                "Lancones",
                "Marcavelica",
                "Miguel Checa",
                "Querecotillo",
                "Salitral",
                "Sullana",
                "El Alto",
                "La Brea",
                "Lobitos",
                "Los Órganos",
                "Máncora",
                "Pariñas"
            ]
        },
        "Lambayeque": {
            number: "03",
            districts: [
                "Chiclayo",
                "Cayaltí",
                "Chiclayo",
                "Chongoyape",
                "Eten",
                "José Leonardo Ortiz",
                "Lagunas",
                "La Victoria",
                "Monsefú",
                "Nueva Arica",
                "Oyotún",
                "Pátapo",
                "Picsi",
                "Pimentel",
                "Pomalca",
                "Pucalá",
                "Puerto Eten",
                "Reque",
                "Saña",
                "Santa Rosa",
                "Tumán",
                "Ferreñafe",
                "Cañaris",
                "Ferreñafe",
                "Incahuasi",
                "Manuel Antonio Mesones Muro",
                "Pítipo",
                "Pueblo Nuevo",
                "Lambayeque",
                "Chóchope",
                "Íllimo",
                "Jayanca",
                "Lambayeque",
                "Mochumí",
                "Mórrope",
                "Motupe",
                "Olmos",
                "Pacora",
                "Salas",
                "San José",
                "Túcume"
            ]
        },
        "La Libertad": {
            number: "04",
            districts: [
                "Ascope",
                "Casa Grande",
                "Chicama",
                "Chocope",
                "Magdalena de Cao",
                "Paiján",
                "Rázuri",
                "Santiago de Cao",
                "Bambamarca",
                "Bolívar",
                "Condormarca",
                "Longotea",
                "Uchumarca",
                "Ucuncha",
                "Chepén",
                "Pacanga",
                "Pueblo Nuevo",
                "Cascas",
                "Lucma",
                "Marmot",
                "Sayapullo",
                "Calamarca",
                "Carabamba",
                "Huaso",
                "Julcán",
                "Otuzco",
                "Agallpampa",
                "Charat",
                "Huaranchal",
                "La Cuesta",
                "Mache",
                "Paranday",
                "Salpo",
                "Sinsicap",
                "Usquil",
                "Pacasmayo",
                "Guadalupe",
                "Jequetepeque",
                "San José",
                "San Pedro de Lloc",
                "Buldibuyo",
                "Chillia",
                "Huancaspata",
                "Huaylillas",
                "Huayo",
                "Ongón",
                "Parcoy",
                "Pataz",
                "Pias",
                "Santiago de Challas",
                "Taurija",
                "Tayabamba",
                "Urpay",
                "Chugay",
                "Cochorco",
                "Curgos",
                "Huamachuco",
                "Marcabal",
                "Sanagorán",
                "Sarín",
                "Sartimbamba",
                "Angasmarca",
                "Cachicadán",
                "Mollebamba",
                "Mollepata",
                "Quiruvilca",
                "Santa Cruz de Chuca",
                "Santiago de Chuco",
                "Sitabamba",
                "El Porvenir",
                "Florencia de Mora",
                "Huanchaco",
                "La Esperanza",
                "Laredo",
                "Moche",
                "Poroto",
                "Salaverry",
                "Simbal",
                "Trujillo",
                "Víctor Larco Herrera",
                "Chao",
                "Guadalupito",
                "Virú"
            ]
        },
        "Ancash": {
            number: "05",
            districts: [
                "Aija",
                "Coris",
                "Huacllán",
                "La Merced",
                "Succha",
                "Aczo",
                "Chaccho",
                "Chingas",
                "Llamellín",
                "Mirgas",
                "San Juan de Rontoy",
                "Acochaca",
                "Chacas",
                "Abelardo Pardo Lezameta",
                "Antonio Raymondi",
                "Aquia",
                "Cajacay",
                "Canis",
                "Chiquián",
                "Colquioc",
                "Huallanca",
                "Huasta",
                "Huayllacayán",
                "La Primavera",
                "Mangas",
                "Pacllón",
                "San Miguel de Corpanqui",
                "Ticllos",
                "Acopampa",
                "Amashca",
                "Anta",
                "Ataquero",
                "Carhuaz",
                "Marcará",
                "Pariahuanca",
                "San Miguel de Aco",
                "Shilla",
                "Tinco",
                "Yungar",
                "San Luis",
                "San Nicolás",
                "Yauya",
                "Buena Vista Alta",
                "Casma",
                "Comandante Noel",
                "Yaután",
                "Corongo",
                "Aco",
                "Bambas",
                "Cusca",
                "La Pampa",
                "Yánac",
                "Yupán",
                "Huaraz",
                "Cochabamba",
                "Colcabamba",
                "Huanchay",
                "Independencia",
                "Jangas",
                "La Libertad",
                "Olleros",
                "Pampas",
                "Pariacoto",
                "Pira",
                "Tarica",
                "Anra",
                "Cajay",
                "Chavín de Huántar",
                "Huacachi",
                "Huacchis",
                "Huachis",
                "Huántar",
                "Huari",
                "Masin",
                "Paucas",
                "Pontó",
                "Rahuapampa",
                "Rapayán",
                "San Marcos",
                "San Pedro de Chaná",
                "Uco",
                "Cochapeti",
                "Culebras",
                "Huarmey",
                "Huayan",
                "Malvas",
                "Caraz",
                "Huallanca",
                "Huata",
                "Huaylas",
                "Mato",
                "Pamparomás",
                "Pueblo Libre",
                "Santa Cruz",
                "Santo Toribio",
                "Yuracmarca",
                "Casca",
                "Eleazar Guzmán Barrón",
                "Fidel OIivas Escudero",
                "Llama",
                "Llumpa",
                "Lucma",
                "Musga",
                "Piscobamba",
                "Acas",
                "Cajamarquilla",
                "Carhuapampa",
                "Cochas",
                "Congas",
                "Llipa",
                "Ocros",
                "San Cristóbal de Raján",
                "San Pedro",
                "Santiago de Chilcas",
                "Bolognesi",
                "Cabana",
                "Conchucos",
                "Huacaschuque",
                "Huandoval",
                "Lacabamba",
                "Llapo",
                "Pallasca",
                "Pampas",
                "Santa Rosa",
                "Tauca",
                "Huayllán",
                "Parobamba",
                "Pomabamba",
                "Quinuabamba",
                "Cátac",
                "Cotaparaco",
                "Huayllapampa",
                "Llacllín",
                "Marca",
                "Pampas Chico",
                "Pararín",
                "Recuay",
                "Tapacocha",
                "Ticapampa",
                "Cáceres del Perú",
                "Chimbote",
                "Coishco",
                "Macate",
                "Moro",
                "Nepeña",
                "Nuevo Chimbote",
                "Samanco",
                "Santa",
                "Acobamba",
                "Alfonso Ugarte",
                "Cashapampa",
                "Chingalpo",
                "Huayllabamba",
                "Quiches",
                "Ragash",
                "San Juan",
                "Sicsibamba",
                "Sihuas",
                "Cascapara",
                "Mancos",
                "Matacoto",
                "Quillo",
                "Ranrahírca",
                "Shupluy",
                "Yanama",
                "Yungay"
            ]
        },
        "Lima y Callao": {
            number: "06",
            districts: [
                "Barranca",
                "Paramonga",
                "Pativilca",
                "Supe",
                "Supe Puerto",
                "Cajatambo",
                "Copa",
                "Gorgor",
                "Huancapón",
                "Manás",
                "Asia",
                "Calango",
                "Cerro Azul",
                "Chilca",
                "Coayllo",
                "Imperial",
                "Lunahuaná",
                "Mala",
                "Nuevo Imperial",
                "Pacarán",
                "Quilmaná",
                "San Antonio",
                "San Luis",
                "Santa Cruz de Flores",
                "San Vicente de Cañete",
                "Zúñiga",
                "Arahuay",
                "Canta",
                "Huamantanga",
                "Huaros",
                "Lachaqui",
                "San Buenaventura",
                "Santa Rosa de Quives",
                "Atavillos Alto",
                "Atavillos Bajo",
                "Aucallama",
                "Chancay",
                "Huaral",
                "Ihuarí",
                "Lampián",
                "Pacaraos",
                "San Miguel de Acos",
                "Santa Cruz de Andamarca",
                "Sumbilca",
                "Veintisiete de Noviembre",
                "Antioquía",
                "Callahuanca",
                "Carampoma",
                "Chicla",
                "Cuenca",
                "Huachupampa",
                "Huanza",
                "Huarochirí",
                "Lahuaytambo",
                "Langa",
                "Laraos",
                "Mariatana",
                "Matucana",
                "Ricardo Palma",
                "San Andrés de Tupicocha",
                "San Antonio",
                "San Bartolomé",
                "San Damián",
                "Sangallaya",
                "San Juan de Iris",
                "San Juan de Tantaranche",
                "San Lorenzo de Quinti",
                "San Mateo",
                "San Mateo de Otao",
                "San Pedro de Casta",
                "San Pedro de Huancayre",
                "Santa Cruz de Cocachacra",
                "Santa Eulalia",
                "Santiago de Anchucaya",
                "Santiago de Tuna",
                "Santo Domingo de los Olleros",
                "Surco",
                "Ámbar",
                "Caleta de Carquín",
                "Checras",
                "Huacho",
                "Hualmay",
                "Huaura",
                "Leoncio Prado",
                "Paccho",
                "Santa Leonor",
                "Santa María",
                "Sayán",
                "Végueta",
                "Ancón",
                "Ate",
                "Barranco",
                "Breña",
                "Carabayllo",
                "Chaclacayo",
                "Chorrillos",
                "Cieneguilla",
                "Comas",
                "El Agustino",
                "Independencia",
                "Jesús María",
                "La Molina",
                "La Victoria",
                "Lima",
                "Lince",
                "Los Olivos",
                "Lurigancho",
                "Lurín",
                "Magdalena del Mar",
                "Miraflores",
                "Pachacámac",
                "Pucusana",
                "Pueblo Libre",
                "Puente Piedra",
                "Punta Hermosa",
                "Punta Negra",
                "Rímac",
                "San Bartolo",
                "San Borja",
                "San Isidro",
                "San Juan de Lurigancho",
                "San Juan de Miraflores",
                "San Luis",
                "San Martín de Porres",
                "San Miguel",
                "Santa Anita",
                "Santa María del Mar",
                "Santa Rosa",
                "Santiago de Surco",
                "Surquillo",
                "Villa El Salvador",
                "Villa María del Triunfo",
                "Andajes",
                "Caujul",
                "Cochamarca",
                "Naván",
                "Oyón",
                "Pachangara",
                "Alis",
                "Ayauca",
                "Ayaviri",
                "Azángaro",
                "Cacra",
                "Carania",
                "Catahuasi",
                "Chocos",
                "Cochas",
                "Colonia",
                "Hongos",
                "Huampara",
                "Huancaya",
                "Huañec",
                "Huangáscar",
                "Huantán",
                "Laraos",
                "Lincha",
                "Madeán",
                "Miraflores",
                "Omas",
                "Putinza",
                "Quinches",
                "Quinocay",
                "San Joaquín",
                "San Pedro de Pilas",
                "Tanta",
                "Tauripampa",
                "Tomas",
                "Tupe",
                "Viñac",
                "Vitis",
                "Yauyos",
                "Bellavista",
                "Callao",
                "Carmen de La Legua-Reynoso",
                "Islas de San Lorenzo y el Frontón",
                "La Perla",
                "La Punta",
                "Mi Perú",
                "Ventanilla"
            ]
        },
        "Ica": {
            number: "07",
            districts: [
                "Alto Larán",
                "Chavín",
                "Chincha Alta",
                "Chincha Baja",
                "El Carmen",
                "Grocio Prado",
                "Pueblo Nuevo",
                "San Juan de Yanac",
                "San Pedro de Huacarpana",
                "Sunampe",
                "Tambo de Mora",
                "Ica",
                "La Tinguiña",
                "Los Aquijes",
                "Ocucaje",
                "Pachacutec",
                "Parcona",
                "Pueblo Nuevo",
                "Salas",
                "San José de los Molinos",
                "San Juan Bautista",
                "Santiago",
                "Subtanjalla",
                "Tate",
                "Yauca del Rosario",
                "Changuillo",
                "El Ingenio",
                "Marcona",
                "Nazca",
                "Vista Alegre",
                "Llipata",
                "Palpa",
                "Río Grande",
                "Santa Cruz",
                "Tibillo",
                "Huancano",
                "Humay",
                "Independencia",
                "Paracas",
                "Pisco",
                "San Andrés",
                "San Clemente",
                "Túpac Amaru Inca"
            ]
        },
        "Arequipa": {
            number: "08",
            districts: [
                "Alto Selva Alegre",
                "Arequipa",
                "Cayma",
                "Cerro Colorado",
                "Characato",
                "Chiguata",
                "Jacobo Hunter",
                "José Luis Bustamante y Rivero",
                "La Joya",
                "Mariano Melgar",
                "Miraflores",
                "Mollebaya",
                "Paucarpata",
                "Pocsi",
                "Polobaya",
                "Quequeña",
                "Sabandía",
                "Sachaca",
                "San Juan de Siguas",
                "San Juan de Tarucani",
                "Santa Isabel de Siguas",
                "Santa Rita de Siguas",
                "Socabaya",
                "Tiabaya",
                "Uchumayo",
                "Vítor",
                "Yanahuara",
                "Yarabamba",
                "Yura",
                "Camaná",
                "José María Quimper",
                "Mariano Nicolás Valcárcel",
                "Mariscal Cáceres",
                "Nicolás de Piérola",
                "Ocoña",
                "Quilca",
                "Samuel Pastor",
                "Acarí",
                "Atico",
                "Atiquipa",
                "Bella Unión",
                "Cahuacho",
                "Caravelí",
                "Chala",
                "Chaparra",
                "Huanuhuanu",
                "Jaqui",
                "Lomas",
                "Quicacha",
                "Yauca",
                "Andagua",
                "Aplao",
                "Ayo",
                "Chachas",
                "Chilcaymarca",
                "Choco",
                "Huancarqui",
                "Machaguay",
                "Orcopampa",
                "Pampacolca",
                "Tipán",
                "Uñón",
                "Uraca",
                "Viraco",
                "Achoma",
                "Cabanaconde",
                "Callalli",
                "Caylloma",
                "Chivay",
                "Coporaque",
                "Huambo",
                "Huanca",
                "Ichupampa",
                "Lari",
                "Lluta",
                "Maca",
                "Madrigal",
                "Majes",
                "San Antonio de Chuca",
                "Sibayo",
                "Tapay",
                "Tisco",
                "Tuti",
                "Yanque",
                "Andaray",
                "Cayarani",
                "Chichas",
                "Chuquibamba",
                "Iray",
                "Río Grande",
                "Salamanca",
                "Yanaquihua",
                "Cocachacra",
                "Deán Valdivia",
                "Islay",
                "Mejía",
                "Mollendo",
                "Punta de Bombón",
                "Alca",
                "Charcana",
                "Cotahuasi",
                "Huaynacotas",
                "Pampamarca",
                "Puyca",
                "Quechualla",
                "Sayla",
                "Tauría",
                "Tomepampa",
                "Toro"
            ]
        },
        "Moquegua": {
            number: "09",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Tacna": {
            number: "10",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Amazonas": {
            number: "11",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Cajamarca": {
            number: "12",
            districts: [
                "district1",
                "district2"
            ]
        },
        "San Martin": {
            number: "13",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Huánuco": {
            number: "10",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Pasco": {
            number: "15",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Junín": {
            number: "16",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Huancavelica": {
            number: "17",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Ayacucho": {
            number: "18",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Apurimac": {
            number: "19",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Cuzco": {
            number: "20",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Puno": {
            number: "21",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Loreto": {
            number: "22",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Ucayali": {
            number: "23",
            districts: [
                "district1",
                "district2"
            ]
        },
        "Madre de Dios": {
            number: "24",
            districts: [
                "district1",
                "district2"
            ]
        }
    }
}